import React, { useEffect, useState } from 'react';
import { SpText } from '../../../widgetDesign';
import { Card, Upload, message } from 'antd';
import { DeleteOutlined, FileOutlined, UploadOutlined } from '@ant-design/icons';
import { DescriptionText, LabelText, PText, SpanText, Text } from '../../../design';
import { inputHeight, normalTextFontSize, smallTextFontSize } from '../../../utils/reseponsive';
import { Controller } from 'react-hook-form';
import { axiosEmptyInstance, getPreSignedUrl, uploadFile } from '../../../api';
type Props = {
  label: string,
  description: string,
  control: any,
  errors: any,
  isRequired: boolean,
  name: string,
  isPreview: boolean,
  isAdaptive: boolean,
  setValue: any,
  quantityMaxLimit: Number,
  quantityMinLimit:Number,
  fileUploadError:Boolean,
}

const InputFileUpload = (props: Props) => {
  const {
    label,
    description,
    quantityMaxLimit,
    isRequired,
    isAdaptive,
    isPreview,
    control,
    setValue,
    errors,
    fileUploadError,
    quantityMinLimit
  } = props;



  const [file, setFile] = useState([]);
  const [docuUrl, setDocuUrl] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [uploadLimitError, setUploadLimitError] = useState(false);
  const fileListStyle = {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5',
    padding: '5px 10px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
  };

  const fileNameStyle = {
    fontSize: smallTextFontSize(isPreview, isAdaptive),
    color: '#333',
    marginLeft: "2px"
  };

  const deleteIconStyle = {
    color: '#ff4d4f',
    cursor: 'pointer',
  };

  const inputStyle = {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    padding: '0 11px',
    height: inputHeight(42, isPreview, isAdaptive),
    backgroundColor: '#fff',
    width: '100%',
    cursor: 'pointer',
    fontSize: smallTextFontSize(isPreview, isAdaptive),
  };

  const iconStyle = {
    marginLeft: 'auto',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  };
  const cardStyle = {
    borderRadius: '10px',
    width: '100%',
    marginTop: '20px',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    padding: "1rem"
  };


  const beforeUpload = (uploadedFile) => {
    // Define allowed MIME types
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    // Check if the uploadedFile type is one of the allowed types
    if (file.length >= quantityMaxLimit) { 
      setUploadLimitError(true);
      return false;
    }
    // if (file.length <= quantityMinLimit) {
    //   setUploadLimitError(true) 
    //   return false;
    // }
    if (!allowedTypes.includes(uploadedFile.type)) {
      setError(true);
      return false;
    }

    setError(false);
    setUploadLimitError(false);
    return true;
  };

  useEffect(() => {
    if (docuUrl)
      setValue("fileUrl", docuUrl);
  }, [docuUrl, setValue])

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file);
  });


  const fileUpload = async (info) => {

    if (info.file.status === 'uploading') {
      setLoading(true);
      return; // Exit early to avoid re-processing the file
    }

    // Only proceed if the status is 'done' or 'error'
    if (info.file.status === 'done' || info.file.status === 'error') {
      try {
        const file = info.file.originFileObj;
        const keyType = "PAYMENT_PAGE_DOCUMENT";

        if (file) {
          const value = await getPreSignedUrl();
          await axiosEmptyInstance.put(value, await fileReader(file), { headers: { 'Content-Type': file.type } });

          const { fileUrl } = await uploadFile(value, keyType);
          setFile((prevFiles) => [
            ...prevFiles,
            { name: info.file.name, fileurl: fileUrl }
          ]);
          setDocuUrl((prevUrls) => [...prevUrls, fileUrl]);
        }
      } catch (e) {
        console.error("File upload error:", e);
        message.error("File upload failed. Please try again.");
      } finally {
        setLoading(false); // Always stop loading
      }
    }
  };



  const handleRemove = (index) => {
    // Remove the file and URL at the specified index
    const updatedFileName = file.filter((_, i) => i !== index);
    const updateFileUrl = docuUrl.filter((_, i) => i !== index);

    setFile(updatedFileName);
    setDocuUrl(updateFileUrl);
  };



  return (

    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Card style={cardStyle} bordered={false}>
          <LabelText fontSize={normalTextFontSize(isPreview, isAdaptive)} color="#0000000"
            hidden={!label} htmlFor="staticEmail" className="col-sm-5 col-form-label font-weight-bolder m-0 text-break">{label}
            <SpanText className="pl-2" hidden={isRequired} color="rgba(0, 0, 0, 0.6)"
              fontSize={smallTextFontSize(isPreview, isAdaptive)}>(Optional)</SpanText></LabelText>
          <PText fontSize={normalTextFontSize(isPreview, isAdaptive)}>{description || ' '}</PText>
          <div className='mt-3'>

            <DescriptionText className="mt-2" fontSize="12px" color="#474747">Upload Document</DescriptionText>
            <Controller
              control={control}
              defaultValue={[]}
              rules={{ required: isRequired && "This field is required" }}
              name="fileUrl"
              as={
                <>
                  <Upload style={iconStyle}
                    onChange={(info) => fileUpload(info)}  
                    beforeUpload={beforeUpload}
                    showUploadList={false} 

                  >

                    <div style={inputStyle} >
                      {/* Simulate input box */}
                      <div style={{ flexGrow: 1 }}>Upload a file</div>
                      <UploadOutlined />
                    </div>
                  </Upload>
                  {file && file.map((e, index) => (
                    <div style={fileListStyle} key={index}>
                      <FileOutlined style={{ color: "#3E8BFF", fontSize: "1rem" }} />
                      <span style={fileNameStyle}>{e.name}</span>
                      <DeleteOutlined
                        style={deleteIconStyle}
                        onClick={() => handleRemove(index)} 
                      />
                    </div>
                  ))}
                </>
              }
            />
          </div>
          {loading && !error && !uploadLimitError &&
            <span className="spinner-border text-muted mt-2 "> </span>
          }
          <br />
          {error && <p className='mt-2' style={{ color: "red", fontSize: "12px" }}>File is not Doc or pdf</p>}
          {fileUploadError && <p className='mt-2' style={{ color: "red", fontSize: "12px" }}>File is Required</p>}
          {uploadLimitError && <p className='mt-2' style={{ color: "red", fontSize: "12px" }}>File Upload Limit Exceeded</p>}
{quantityMinLimit !==0 && <><SpText fontStyle="italic" className="mt-2 " fontSize={smallTextFontSize(isPreview, isAdaptive)} color="rgba(0, 0, 0, 0.5)"><span style={{ color: 'red' }}>*</span>Minimum {quantityMinLimit} Documents</SpText><br /></>}         
 <SpText fontStyle="italic" className="mt-2 " fontSize={smallTextFontSize(isPreview, isAdaptive)} color="rgba(0, 0, 0, 0.5)">Maximum {quantityMaxLimit && quantityMaxLimit} Documents</SpText>
        </Card>
      </div>
    </>
  );
};

export default InputFileUpload;